import { all } from 'redux-saga/effects';

import { coordinatesSaga } from './coordinates';

export default function* () {
    yield all([coordinatesSaga()]);
}
